import { useQuery } from '@tanstack/react-query';

import { getChatItinerarySnapshot, getChatSnapshotMessages } from '~/services/TripPlannerService';

import { tripPlannerQueryKeys } from './tripPlannerQueryKeys';

export function useChatItinerarySnapshot(chatId: string, messageId?: string) {
  return useQuery({
    queryKey: [...tripPlannerQueryKeys.all, 'itinerary-snapshot', chatId, messageId],
    queryFn: ({ signal }) => getChatItinerarySnapshot(chatId, messageId, { signal }),
    enabled: Boolean(messageId),
    retry: false,
    refetchOnWindowFocus: false,
  });
}

export function useChatSnapshotMessages(chatId: string, enabled: boolean) {
  return useQuery({
    queryKey: [...tripPlannerQueryKeys.all, 'snapshot-messages', chatId],
    queryFn: ({ signal }) => getChatSnapshotMessages(chatId, { signal }),
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
